class BFFResponse {
  private data: unknown;
  private errors: unknown;

  constructor(data: unknown, errors: unknown = {}) {
    this.data = data;
    this.errors = errors;
  }

  setData = (data: unknown) => {
    this.data = data;
    return this;
  };

  getData() {
    return this.data;
  }

  setErrors = (error: unknown) => {
    this.data = error;
    return this;
  };

  getErrors() {
    return this.errors;
  }

  get() {
    return {
      data: this.getData(),
      errors: this.getErrors(),
    };
  }
}

export default BFFResponse;
